import React from 'react';
import { Eye, Target } from 'lucide-react';
import vision2 from '../../assets/images/vision2.png';
import mission2 from '../../assets/images/mission2.png';
import './Vision.css';

const Vision = () => {
    return (
        <section className="cb-vision-section" id="vision">
            <div className="cb-vision-glow"></div>
            <div className="container">
                <div className="cb-section-title-wrap">
                    <div className="cb-studio-tag">[ 04 // STRATEGIC DIRECTION ]</div>
                    <h2 className="cb-section-title">
                        Vision & Mission
                    </h2>
                </div>

                <div className="cb-vision-container">
                    <div className="cb-vm-card">
                        <div>
                            <div className="cb-vm-header-pill">
                                <Eye size={14} strokeWidth={2} />
                                <span className="cb-vm-index">VISION // 01</span>
                            </div>
                            <h3 className="cb-vm-title">Vision</h3>
                            <p className="cb-vm-text">
                                Our vision is to emerge as one of the top open research communities in India, 
                                embracing the expansive horizons of chemistry, biology, and AI. Also to be recognized 
                                for our unwavering commitment to fostering collaboration, innovation, and the advancement 
                                of open research practices. We aspire to lead the way in creating a dynamic and influential 
                                community that significantly contributes to the research landscape in India and beyond.
                            </p>
                        </div>
                        <div className="cb-vm-img-wrap">
                            <img src={vision2} alt="Vision" className="cb-vm-img" />
                        </div>
                    </div>

                    <div className="cb-vm-card cb-mission-card">
                        <div>
                            <div className="cb-vm-header-pill">
                                <Target size={14} strokeWidth={2} />
                                <span className="cb-vm-index">MISSION // 02</span>
                            </div>
                            <h3 className="cb-vm-title">Mission</h3>
                            <p className="cb-vm-text">
                                We are on a mission to create inspiring and educational content for investors and deep tech founders. 
                                We aim to focus on community, inspiration, networking and growing together. We aim to help them 
                                to come together, brainstorm and grow together with support.
                            </p>
                        </div>
                        <div className="cb-vm-img-wrap">
                            <img src={mission2} alt="Mission" className="cb-vm-img" />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Vision;